import { InstanceTypeOf } from '@/type-utils';
import { IHTTPErrorMetaData } from '@/utils/api-utils/IHTTPErrorMetaData';
import { errorFactory } from '@/utils/error-utils';

export const { InvalidCredentialsError } = errorFactory(
  'InvalidCredentialsError',
  {
    mapsToHTTPError: 'UnauthorizedError'
  } as IHTTPErrorMetaData
);

/** Error to use to indicate that supplied credentials are incorrect. */
export type InvalidCredentialsError = InstanceTypeOf<
  typeof InvalidCredentialsError
>;
